import {
  Component, Inject, OnInit, OnDestroy,
  ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogRef,
} from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';

import { AuthService } from 'src/app/services/auth.service';
import { EntityService } from 'src/app/services/entity.service';
import { UploadFileComponent } from 'src/app/components/upload-file/upload-file.component';  // <— NEW
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-edit-entity-logo',
  templateUrl: './edit-entity-logo.component.html',
  styleUrls: [ './edit-entity-logo.component.scss' ],
})
export class EditEntityLogoComponent {
  loggedIn$ = false;
  user$: Observable<any>;
  entity$: Observable<any>;
  logoSrc!: string;
  fileTypeInS3 = 'ENTITY_LOGO' as const;

  private loggedInSubscription!: Subscription;
  private userSubscription!: Subscription;

  @ViewChild(UploadFileComponent) uploadFileComponent!: UploadFileComponent;

  constructor(
    private authService: AuthService,
    private entityService: EntityService,
    private usersService: UsersService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditEntityLogoComponent>,
  ) {}

  ngOnInit(): void {
    this.user$ = this.authService.user$;
    this.entity$ = this.authService.entity$;

    this.loggedInSubscription = this.authService.loggedIn$
      .subscribe((status: boolean) => {
        this.loggedIn$ = status;
        if (status) {
          this.loadEntityLogo();
        }
      });
  }

  ngOnDestroy(): void {
    this.loggedInSubscription?.unsubscribe();
    this.userSubscription?.unsubscribe();
  }

  loadEntityLogo(): void {
    this.authService.user$.subscribe(user => {
      if (user?.loginName) {
        this.entityService.getEntityLogo(user.loginName).subscribe({
          next: (response: any) => {
            if (response?.data?.logoUrl) {
              this.logoSrc = response.data.logoUrl;
            }
          },
          error: err => console.error('Failed to load entity logo:', err),
        });
      }
    }).unsubscribe();
  }

  saveLogo(): void {
    this.uploadFileComponent.startUpload(new Event(''));
    this.dialogRef.close();
  }

  removeImage(): void {
    if (!this.uploadFileComponent) {
      console.error('Cannot remove image: child UploadFileComponent not yet instantiated.');
      return;
    }
    this.uploadFileComponent.removeCurrentEntityLogo();

    setTimeout(() => {
      this.entityService.triggerLogoReload();
    }, 1000);
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
